"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMPTY_ARRAY = void 0;
exports.EMPTY_ARRAY = [];
//# sourceMappingURL=array.js.map